import { RJSFSchema, UiSchema } from "@rjsf/utils";
import { customizeValidator } from "@rjsf/validator-ajv8";
import JSONSchemaForm from "@rjsf/core";
import { useTranslation } from "react-i18next";
import { MouseEventHandler, useContext, useEffect, useState } from "react";
import customFormats from "@beeldit/core/custom-validations/custom-validation";
import useProcessSchema from "@beeldit/core/hooks/useProcessSchema";
import widgets from "@beeldit/core/widgets/widgets";
import ConfigurationFormTemplate from "./ConfigurationFormTemplate";

interface Prop {
  formConfig: {
    formRef: any;
    onSubmit: any;
    context: any;
  };
}

interface Context {
  element: any;
  setElement: (element: any) => MouseEventHandler;
  backendFormErrors: any;
}

function ConfigurationForm(props: Prop) {
  const { formRef, onSubmit, context } = props.formConfig;
  const { element, setElement, backendFormErrors } =
    useContext<Context>(context);

  const { t } = useTranslation();

  const translations = {
    sales_commission: t("sales_commission"),
    tax_sales_commission: t("tax_sales_commission"),
    shipments: t("shipments"),
    tax_shipments: t("tax_shipments"),
    shipping_minimum: t("shipping_minimum"),
    shipping_maximum: t("shipping_maximum"),
  };

  let schema: any = {
    type: "object",
    properties: {
      sales_commission: {
        type: "number",
        title: translations.sales_commission,
        min: 0,
      },
      tax_sales_commission: {
        type: "number",
        title: translations.tax_sales_commission,
        min: 0,
      },
      shipments: {
        type: "number",
        title: translations.shipments,
        min: 0,
      },
      tax_shipments: {
        type: "number",
        title: translations.tax_shipments,
        min: 0,
      },
      shipping_minimum: {
        type: "number",
        title: translations.shipping_minimum,
        description: t("shipping_minimum_help"),
        min: 0,
      },
      shipping_maximum: {
        type: "number",
        title: translations.shipping_maximum,
        description: t("shipping_maximum_help"),
        min: 0,
      },
      address: {
        type: "string",
        title: t("address"),
        minLength: 0,
      },
      phone: {
        type: "string",
        title: t("phone"),
        minLength: 0,
      },
      email: {
        type: "string",
        title: t("email"),
        minLength: 0,        
      }
    },
  };


  const uiSchema = {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },      
      norender: true,
    },
  };
  const customWidgets = {
    ...widgets,
  };
  const handleChange = (type: any) => {
    /** Este método de momento es necesario aunque en realidad no tenga sentido, pero se debe a un bug de la libreria */
    // Actualizar el estado solo si no hay errores de validación
    setElement(type.formData);
    return console.log.bind(console, type);
  };
  const log = (type: any) => {
    return console.log.bind(console, type);
  };

  const formats = customFormats;
  const validator = customizeValidator({ customFormats: formats });

  const formTemplate = ConfigurationFormTemplate;

  // No renderizar el formulario hasta que element tenga datos
  if (!element || !element.id) {
    return <div>{t('loading')}</div>;
  }

  return (
    <JSONSchemaForm
      noHtml5Validate
      showErrorList={false}
      ref={formRef}
      schema={schema}
      uiSchema={uiSchema}
      widgets={customWidgets}
      formData={element}
      validator={validator}
      onChange={handleChange}
      onSubmit={onSubmit}
      onError={log("errors")}
      extraErrors={backendFormErrors}
      templates={{
        ObjectFieldTemplate: formTemplate,
      }}
    />
  );
}

export default ConfigurationForm;
